import PrimaryButton from "components/buttons/primary-button";
import Typography from "components/typography";
import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Colors } from "utils/colors";

const ProCard = ({ isMonthly }: { isMonthly: boolean }) => {
  const navigate = useNavigate();

  const Confirm = () => {
    navigate("/pricing/summary", {
      state: { isMonthly, ActivePackage: "pro" }
    });
  };
  return (
    <Container>
      <Header>
        <HeaderText>
          <ProText>
            <Typography weight="semibold" size="xl">
              Pro
            </Typography>
            <PopularContainer>
              <Typography size="xs">popular</Typography>
            </PopularContainer>
          </ProText>
        </HeaderText>
        <Icon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 22 22"
            fill="none"
          >
            <path
              d="M20.4352 8.44051C20.3545 8.19166 20.2023 7.97206 19.9977 7.80907C19.7931 7.64607 19.545 7.54688 19.2844 7.52384L14.3352 7.09717L12.3952 2.48384C12.2942 2.24177 12.1239 2.03499 11.9056 1.88955C11.6873 1.74411 11.4309 1.6665 11.1686 1.6665C10.9063 1.6665 10.6498 1.74411 10.4316 1.88955C10.2133 2.03499 10.0429 2.24177 9.94191 2.48384L8.00774 7.09717L3.05274 7.52634C2.7911 7.54832 2.54178 7.64707 2.33604 7.81018C2.1303 7.9733 1.97729 8.19353 1.89622 8.44326C1.81514 8.69299 1.8096 8.9611 1.88029 9.21396C1.95098 9.46682 2.09475 9.69319 2.29357 9.86467L6.05274 13.1497L4.92607 18.028C4.8665 18.2833 4.8835 18.5505 4.97495 18.7962C5.0664 19.0418 5.22824 19.2551 5.44024 19.4093C5.65223 19.5635 5.90498 19.6518 6.16688 19.6631C6.42879 19.6744 6.68822 19.6083 6.91274 19.473L11.1627 16.8897L15.4219 19.473C15.6464 19.6083 15.9059 19.6744 16.1678 19.6631C16.4297 19.6518 16.6824 19.5635 16.8944 19.4093C17.1064 19.2551 17.2683 19.0418 17.3597 18.7962C17.4511 18.5505 17.4681 18.2833 17.4086 18.028L16.2827 13.1447L20.0411 9.86467C20.2399 9.6926 20.3834 9.46559 20.4535 9.21219C20.5236 8.95879 20.5173 8.69031 20.4352 8.44051ZM19.1669 8.85717L15.4086 12.1372C15.2257 12.2963 15.0896 12.5023 15.015 12.7329C14.9404 12.9636 14.9301 13.2103 14.9852 13.4463L16.1144 18.333L11.8586 15.7497C11.6509 15.6232 11.4125 15.5563 11.1694 15.5563C10.9263 15.5563 10.6879 15.6232 10.4802 15.7497L6.23024 18.333L7.35191 13.4497C7.40703 13.2136 7.39675 12.9669 7.32215 12.7363C7.24756 12.5056 7.11149 12.2996 6.92857 12.1405L3.16857 8.86217C3.16827 8.85968 3.16827 8.85716 3.16857 8.85467L8.12191 8.42634C8.36374 8.40502 8.59517 8.31808 8.79122 8.1749C8.98727 8.03171 9.14051 7.83772 9.23441 7.61384L11.1686 3.00634L13.1019 7.61384C13.1958 7.83772 13.349 8.03171 13.5451 8.1749C13.7411 8.31808 13.9726 8.40502 14.2144 8.42634L19.1686 8.85467V8.8605L19.1669 8.85717Z"
              fill="#FFE369"
            />
          </svg>
        </Icon>
      </Header>
      <Typography color={Colors.grey300} mb="3.4">
        Advanced tools and analytics for serious artists and creators, with
        added benefits like daily stream stats, synch lyrics, custom release
        dates etc.
      </Typography>
      <PriceDiv>
        <Typography size="4.8rem" weight="semibold" mr="0.8">
          $4
        </Typography>
        <Typography lh="4" color={Colors.grey500}>
          per month
        </Typography>
      </PriceDiv>

      <PrimaryButton
        text="Get Access To Professional Tools"
        onClick={Confirm}
        inset
      />
    </Container>
  );
};

export default ProCard;

const Container = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 0.8rem;
  padding: 1.6rem;
  border: 0.1rem solid #ffe369;
  background: linear-gradient(
    108deg,
    rgba(30, 30, 30, 0.8) 0.85%,
    rgba(19, 19, 19, 0.8) 100%
  );
  position: relative;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 3.4rem;
  @media only screen and (max-width: 769px) {
    margin-bottom: 2.4rem;
  }
`;

const ProText = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.8rem;
`;

const PopularContainer = styled.div`
  padding: 0.2rem 1.2rem;
  border-radius: 50px;
  border: 0.5px solid #ffe369;
  background: rgba(255, 227, 105, 0.1);
  backdrop-filter: blur(15.75px);
  color: #ffe369;
  position: absolute;
  top: -1rem;
  margin-left: 3.5rem;
  @media only screen and (max-width: 769px) {
    margin-left: 40%;
  }
`;
const HeaderText = styled.div``;

const Icon = styled.div`
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 50%;
  border-top: 1px solid #ffe369;

  background: #0d0d0d;
  box-shadow: 0px 4px 4px 0px rgba(50, 50, 50, 0.5) inset;
  padding: 0.5rem;
`;

const PriceDiv = styled.div`
  display: flex;
  align-items: end;
  margin-bottom: 2.4rem;
`;
